import { createSyncHook } from "@modern-js/plugin-v2";
var modifyRoutes = createSyncHook();
var onBeforeCreateRoutes = createSyncHook();
export {
  modifyRoutes,
  onBeforeCreateRoutes
};
